<div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 2000; margin-top: 60px;">
    <ng-container *ngFor="let toast of toastService.toasts">
        <div class="toast fade show" role="alert" aria-live="assertive" aria-atomic="true"
            (mouseenter)="toastService.pause(toast)" (mouseleave)="toastService.resume(toast)">

            <div class="toast-header" [ngClass]="{
          'bg-success text-white': toast.type === 'success',
          'bg-danger text-white': toast.type === 'error',
          'bg-warning text-dark': toast.type === 'warning',
          'bg-info text-dark': toast.type === 'info'
        }">
                <strong class="me-auto">{{ toast.title || (toast.type | uppercase) }}</strong>
                <button type="button" class="btn-close btn-close-white" aria-label="Close"
                    (click)="toastService.remove(toast)"></button>
            </div>

            <div class="toast-body">
                <ng-container *ngIf="isTemplate(toast.textOrTpl); else normalText">
                    <ng-container *ngTemplateOutlet="toast.textOrTpl"></ng-container>
                </ng-container>
                <ng-template #normalText>{{ toast.textOrTpl }}</ng-template>
            </div>

        </div>
    </ng-container>
</div>